const colorArray = [
	"#ba7ded",
	"#74e0ae",
	"#ee7883",
	"#f5b39c",
	"#81a5e7",
	"#83d3ed",
	"#ff7729",
	"#a1e31e",
	"#3920ba",
	"#5bad55",
	"#75e0d0",
	"#eb7ba8",
	"#edb375",
	"#9deb2e",
	"#2ec1eb",
	"#af2eeb",
	"#eb2ece",
	"#ebd32e",
	"#eb6c2e",
	"#2eebbc",
	"#ebeb2e",
	"#eb2e2e",
	"#2eeb83",
	"#eba62e",
	"#2eebb9",
	"#2ea3eb",
	"#eb802e",
	"#eb2eb9",
	"#eb2e4e",
	"#41eb2e",
]

export default colorArray